import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment.prod';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';

const url = environment.wsUrl

@Injectable({
  providedIn: 'root'
})
export class ExpedientesService {

  constructor(private http: HttpClient) {
  }

  obtenerTipoExpediente(): Observable<any> {
    return this.http.get(url + 'expediente/obtenerTipoExpediente');
  }

  administrarTipoExpediente(data): Observable<any> {
    return this.http.post(url + 'expediente/administrarTipoExpediente', data);
  }

  administrarExpedientes(data) {
    return this.http.post(url + 'expediente/administrarExpediente', data);
  }

  obteneridExpediente(data) {
    return this.http.post(url + 'expediente/obtenerExpediente', data);
  }

  obtenerTiposDocumentos() {
    return this.http.get(url + 'xccm/type/consultarNodeType');
  }

  obtenerFactura() {
    let rfc = sessionStorage.getItem('empresaRFC');
    let nombrePeriodo = sessionStorage.getItem('nombrePeriodo');
    let ejercicio = sessionStorage.getItem('ejercicio');

    if (rfc == undefined || rfc == 'undefined' || rfc == null) {
      return of([]);
    }

    let data = {
      rfc: rfc,
      ejercicio: ejercicio,
      mes: nombrePeriodo
    };
    // ${url}empresa/CNA890116SF2/facturacion/ejercicio/2024/mes/Enero

    // ${url}repse/empresa/AABH790704RC5/facturacion/ejercicio/2025/mes/Enero
    return this.http.get(url + 'repse/empresa/' + data.rfc + '/facturacion/ejercicio/' + data.ejercicio + '/mes/' + data.mes);
  }

  obtenerDocumentosMes(mes: string) {
    return this.http.get(url + 'repse/empresa/cumplimiento/mes/' + mes);

  }

}
